import React from 'react';
import {useState, useEffect} from 'react';
import {Button, Input, Table} from "antd";
import {ADMIN_CONFIGURATIONS_MODAL} from "../../Modal/types";
import languages from "../../../language/languages";
import _ from 'lodash';

const ConfigurationTable = (props) => {
  const [filteredDataSource, setFilteredDataSource] = useState([]);

  useEffect(() => {
    setFilteredDataSource(props.dataSource);
  }, [props.dataSource]);

  const columns = [{
    title: languages[props.language].name_column,
    dataIndex: 'paramName',
    className: 'mobile-show'
  }, {
    title: languages[props.language].value_column,
    dataIndex: 'paramValue',
    className: 'mobile-hide'
  },{
    title: languages[props.language].action_column,
    key: 'action',
    render: (text, record) => (
        <span>
          <Button type={'primary'} htmlType={'button'} onClick={() => handleUpdate(record)}>
            {languages[props.language].editLabel}
          </Button>
        </span>
    ),
    className: 'mobile-show'
  }];

  const handleUpdate = (record) => {
    props.modalShow({
      modalType: ADMIN_CONFIGURATIONS_MODAL,
      modalProps: {footer: null, title: languages[props.language].editLabel},
      componentProps: {language: props.language, btn: languages[props.language].editLabel, entry: record, onSubmit: props.setConfigurationParam}
    });
  };

  const renderHeader = () => {
    return(
        <div>
          <Input.Search
              placeholder={languages[props.language].searchLabel}
              onSearch={value => handleFilter(value)}
              enterButton
          />
        </div>
    );
  };

  const handleFilter = (value = null) => {
    if(value) {
      setFilteredDataSource(_.without(_.map(props.dataSource, (o) => {if(o.paramName.toLowerCase().includes(value.toLowerCase())) {return o;}}), undefined));
    } else {
      return setFilteredDataSource(props.dataSource);
    }
  };

  return (
      <div>
        <Table
            columns={columns}
            dataSource={filteredDataSource}
            title={renderHeader}
            rowKey={'paramName'}
        />
      </div>
  );
};

export default ConfigurationTable;